export default "__VITE_ASSET__969d0170__"